import { render, staticRenderFns } from "./AssigneeChip.vue?vue&type=template&id=cc11573e&scoped=true&"
import script from "./AssigneeChip.vue?vue&type=script&lang=js&"
export * from "./AssigneeChip.vue?vue&type=script&lang=js&"
import style0 from "./AssigneeChip.vue?vue&type=style&index=0&id=cc11573e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc11573e",
  null
  
)

export default component.exports